/**
 * Global pagination defaults shared by every table.
 *
 * The paginator only appears once a table holds more rows than the smallest
 * page size — paginating 5 or fewer rows adds chrome without adding value.
 */
export const DEFAULT_PAGE_SIZE = 5;

export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

export const MIN_ROWS_FOR_PAGINATION = PAGE_SIZE_OPTIONS[0];

/**
 * Single corner radius for every table container (Figma 6222:4023).
 * Paired with `overflow-hidden` so the header background is clipped by it.
 */
export const TABLE_RADIUS = "rounded-[28px]";
